// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"none\" viewBox=\"0 0 16 16\"><circle cx=\"8\" cy=\"8\" r=\"7.25\" stroke=\"#fff\" stroke-width=\"1.5\"/><circle cx=\"8\" cy=\"8\" r=\"2.667\" fill=\"#fff\"/></svg> ";
// Exports
module.exports = code;